import { Container } from "./DashboardStyle";
import theme from "../../styles/theme";
import AuthContext from "../../contexts/authContext";

import { useContext, useEffect, useState } from "react";
import { useStateIfMounted } from "use-state-if-mounted";
import { NavLink, Route, Switch } from 'react-router-dom';
import api from "../../services/api";
import Spinner from "../../shared/Spinner/Spinner";

import BillsCopies from "../BillsCopies/BillsCopiesTable";
import MessagesTable from "../Messages/MessagesTable";
import Messages from "../Messages/Messages";
import Tasks from "../Tasks/TasksTable";
import TasksDetails from "../Tasks/TaskDetails";
import EnterprisesUpdatesList from "../EnterpriseUpdates/EnterprisesUpdatesTable";
import EnterpriseUpdate from "../EnterpriseUpdates/EnterpriseUpdate";
import OrdersTable from "../Orders/OrdersTable";
import ProductsTable from "../Products/ProductsTable";
import ProductDetails from "../Products/ProductDetails";
import VariationDetails from "../Products/Variations/VariationProductsDetails";
import VariationProductGroupDetails from "../Products/Variations/VariationProductGroupDetails";
import MessagesToAll from "../Messages/MessagesToAll";
import MessagesToGroups from "../Messages/MessagesToGroups";
import UsersTable from "../Users/UsersTable";
import UserDetails from "../Users/UserDetails";
import Suppliers from "../Suppliers/SuppliersTable";
import CreateCompany from "../CreateCompany/CreateCompany";
import AdminsTable from "../Admins/AdminsTable";
import CreateEditAdmin from "../Admins/AdminDetail";
import InstallmentsTable from "../Installments/InstallmentsTable";
import VariationPlans from "../Plans/Variations/VariationPlansDetail";


import {
  FaUsers, FaChevronDown, FaChevronRight, FaEnvelope, FaBuilding, FaFileContract, FaFileInvoiceDollar, FaFileDownload,
  FaTag, FaUserTag, FaPaintRoller, FaTags, FaUserTie, FaUserEdit, FaFileAlt,
  FaCreditCard
} from "react-icons/fa";

import InstallmentsDetail from "../Installments/InstallmentsDetail";
import ContractTemplate from "../ContractTemplate/ContractTemplateTable";
import ContractTable from "../Contracts/ContractTable";
import OrderDetails from "../Orders/OrderDetails";
import MaterialDetails from "../Materials/MaterialDetails";
import MaterialsTable from "../Materials/MaterialsTable";
import CreateAdmin from "../CreateAdmin/CreateAdmin";
import EnterprisesTable from "../Enterprises/EnterprisesTable";
import Enterprise from "../Enterprises/EnterpriseMenu";
import EnterprisesDetail from "../Enterprises/EnterpriseDetails";
import BlocksTable from "../Enterprises/Blocks/BlocksTable";
import BlocksDetail from "../Enterprises/Blocks/BlocksDetail";
import PlansTable from "../Plans/PlansTable";
import PlansDetail from "../Plans/PlansDetail";
import ContractTemplateDetail from "../ContractTemplate/ContractTemplateDetail";
import CategoriesTable from "../Categories/CategoriesTable";
import CategoryDetails from "../Categories/CategoryDetails";
import EditUser from "../Users/EditUser";
import ApartmentsGenerator from "../Apartments/ApartmentsGenerator";
import ApartmentsDetail from "../Apartments/ApartmentDetail";
import PageTitle from "../../components/PageTitle";
import EnterpriseInfo from "../Enterprises/Infos/EnterpriseInfo";
import EnterpriseTextConfig from "../Enterprises/TextConfigs/EnterpriseTextConfig";
import EnterpriseTextConfigPage from "../Enterprises/TextConfigs/EnterpriseTextConfigPage";
import EnterpriseInfoPage from "../Enterprises/Infos/EnterpriseInfoPage";
import Ratings from "../Enterprises/Ratings/Ratings";
import EnterpriseReport from "../Enterprises/Report/EnterpriseReport";
import PaymentOptionPage from "../Enterprises/Installments/PaymentOption/PaymentOptionPage";
import CreatePaymentOption from "../Enterprises/Installments/PaymentOption/CreatePaymentOption";
import InstallmentPage from "../Enterprises/Installments/InstallmentPage/InstallmentPage";
import EnterprisePaymentOptions from "../Enterprises/Installments/EnterprisePaymentOptions";
import ClickSignDetails from "../Enterprises/ClickSign/ClickSignDetails";
import { UserJournal } from "../Users/UserJournal";
import { UserJournalSession } from "../Users/UserJournalSession";
import CreditAnalysis from "../CreditAnalysis/CreditAnalysisTable";

export default function BoardsList(props) {
  const [logoUrl, setLogoUrl] = useStateIfMounted("");
  const [checkingLogin, setCheckingLogin] = useState(true);
  const { LogOut, userData, ValidateLogin } = useContext(AuthContext);
  const [contractsMenuOpen, setContractsMenuOpen] = useState(false);
  const isMasterCompany = userData.companyId === 1;

  useEffect(() => {
    setCheckingLogin(true);
    ValidateLogin().then(OnValidateLogin).catch(error => {
      OnInvalidLogin();
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  async function OnValidateLogin(valid: boolean) {
    setCheckingLogin(false);
    if (!valid) {
      OnInvalidLogin();
    }
    else {
      GetCompanyLogo();
    }
  }

  function OnInvalidLogin() {
    LogOut();
    props.history.push("/");
  }

  async function GetCompanyLogo() {
    const requestResult = (await api.get(`companies/${userData.companyId}/logo`)).data;
    if (!requestResult.success) {
      console.log("Não foi possível pegar a logo da empresa");
      return;
    }

    setLogoUrl(requestResult.logo);
  }

  return (
    <>
      <PageTitle title="Dashboard" iconURL="https://yt3.ggpht.com/ytc/AAUvwnhffNrx3iCyg86z3CfxBTcSlGXnj8oYExMkq-vV=s68-c-k-c0x00ffffff-no-rj" />
      <Container theme={theme}>
        <header>
          <h2>Olá, {userData.userName.split(' ')[0]}</h2>
          <button onClick={() => LogOut()}>
            Sair
          </button>
        </header>
        <div className="logo">
          {logoUrl !== "" && <img src={logoUrl} alt="Logo" />}
        </div>
        <aside>
          <NavLink to="/users" activeClassName="active-link" ><FaUsers className="icon" />Clientes</NavLink>
          <NavLink to="/messages" activeClassName="active-link" ><FaEnvelope className="icon" />Mensagens</NavLink>
          <NavLink to="/enterprises" activeClassName="active-link" ><FaBuilding className="icon" />Empreendimentos</NavLink>
          <NavLink to="/plans" activeClassName="active-link" ><FaFileAlt className="icon" />Plantas</NavLink>
          <NavLink to="#" onClick={() => setContractsMenuOpen(!contractsMenuOpen)}>
            <FaFileContract className="icon" />Contratos gerados
            {contractsMenuOpen ? <FaChevronDown className="iconDown" /> : <FaChevronRight className="iconDown" />}
          </NavLink>
          {contractsMenuOpen && (
            <div className="subMenu" >
              <NavLink exact to="/contracts" activeClassName="active-link">
                <FaFileContract className="icon" />Contratos
              </NavLink>
              <NavLink to="/contracts/templates" activeClassName="active-link">
                <FaFileInvoiceDollar className="icon" />Templates
              </NavLink>
            </div>
          )}

          <NavLink to="/orders" activeClassName="active-link"><FaFileInvoiceDollar className="icon" />Pedidos</NavLink>
          <NavLink to="/creditAnalysis" activeClassName="active-link"><FaCreditCard className="icon" />Analises de crédito</NavLink>

          <NavLink to="/billsCopies" activeClassName="active-link"><FaFileDownload className="icon" />Pedidos de 2ª via</NavLink>
          <NavLink to="/products" activeClassName="active-link"><FaTag className="icon" />Itens</NavLink>
          {isMasterCompany && <NavLink to="/categories" activeClassName="active-link"><FaTags className="icon" />Categorias</NavLink>}
          <NavLink to="/Installments" activeClassName="active-link"><FaUserTag className="icon" />Parcelas</NavLink>
          <NavLink to="/suppliers" activeClassName="active-link"><FaUserTag className="icon" />Fornecedores</NavLink>
          <NavLink to="/materials" activeClassName="active-link"><FaPaintRoller className="icon" />Materiais</NavLink>
          {/* Alterar isso para checar de forma melhor se é da empresa "editora" */}
          {isMasterCompany && <NavLink to="/dashboard/addCompany" activeClassName="active-link" ><FaUserTie className="icon" />Criar empresa</NavLink>}
          <NavLink to="/admin" activeClassName="active-link"  ><FaUserEdit className="icon" />Admins</NavLink>
          {isMasterCompany && <NavLink to="/dashboard/createAdmin" activeClassName="active-link" ><FaUserEdit className="icon" />Criar Admins</NavLink>}
        </aside>
        {
          checkingLogin && <main>
            <Spinner spinning={checkingLogin} />
          </main>
        }
        {!checkingLogin && <main>
          <Switch>
            <Route path="/users/:userId/edit" component={EditUser} />
            <Route path="/users/:userId/journal/:sessionId" component={UserJournalSession} />
            <Route path="/users/:userId/journal" component={UserJournal} />

            <Route path="/users/:userId" component={UserDetails} />
            <Route path="/users" component={UsersTable} />

            <Route path="/messages/toGroups" component={MessagesToGroups} />
            <Route path="/messages/toAll" component={MessagesToAll} />
            <Route path="/messages/:userId" component={Messages} />
            <Route path="/messages" component={MessagesTable} />

            <Route path="/enterprises/blocks/apartment/:apartmentId" component={ApartmentsDetail} />
            <Route path="/enterprises/blocks/:blockId/newApartment" component={ApartmentsDetail} />
            <Route path="/enterprises/:enterpriseId/blocks/:blockId/create" component={ApartmentsGenerator} />
            <Route path="/enterprises/:enterpriseId/blocks/:blockId" component={BlocksDetail} />
            <Route path="/enterprises/:enterpriseId/blocks" component={BlocksTable} />
            <Route path="/enterprises/create" component={EnterprisesDetail} />

            <Route path="/enterprises/edit/:enterpriseId" component={EnterprisesDetail} />
            <Route path="/enterprises/:enterpriseId/tasks/:taskId" component={TasksDetails} />
            <Route path="/enterprises/:enterpriseId/updates/:updateId" component={EnterpriseUpdate} />
            <Route path="/enterprises/:enterpriseId/tasks" component={Tasks} />
            <Route path="/enterprises/:enterpriseId/updates" component={EnterprisesUpdatesList} />
            <Route path="/enterprises/:enterpriseId/info/:infoId" component={EnterpriseInfoPage} />
            <Route path="/enterprises/:enterpriseId/info" component={EnterpriseInfo} />
            <Route path="/enterprises/:enterpriseId/textConfigs/:infoId" component={EnterpriseTextConfigPage} />
            <Route path="/enterprises/:enterpriseId/textConfigs" component={EnterpriseTextConfig} />
            <Route path="/enterprises/:enterpriseId/ratings" component={Ratings} />

            <Route path="/enterprises/:enterpriseId/report" component={EnterpriseReport} />

            <Route path="/enterprises/:enterpriseId/paymentOptions/create" component={CreatePaymentOption} />
            <Route path="/enterprises/:enterpriseId/paymentOptions/:paymentOptionId/installment/:installmentId" component={InstallmentPage} />
            <Route path="/enterprises/:enterpriseId/paymentOptions/:paymentOptionId" component={PaymentOptionPage} />
            <Route path="/enterprises/:enterpriseId/paymentOptions" component={EnterprisePaymentOptions} />

            <Route path="/enterprises/:enterpriseId/clickSign" component={ClickSignDetails} />

            <Route path="/enterprises/:enterpriseId" component={Enterprise} />
            <Route path="/enterprises" component={EnterprisesTable} />


            <Route path="/contracts/templates/create" component={ContractTemplateDetail} />
            <Route path="/contracts/templates" component={ContractTemplate} />
            <Route path="/contracts" component={ContractTable} />

            <Route path="/orders/:orderId" component={OrderDetails} />
            <Route path="/orders" component={OrdersTable} />
            <Route path="/creditAnalysis" component={CreditAnalysis} />


            <Route path="/billsCopies" component={BillsCopies} />

            <Route path="/plans/:planId/:variationId" component={VariationPlans} />
            <Route path="/plans/:planId" component={PlansDetail} />
            <Route path="/plans" component={PlansTable} />

            <Route path="/products/:productId/:variationId/:groupId" component={VariationProductGroupDetails} />
            <Route path="/products/:productId/:variationId" component={VariationDetails} />
            <Route path="/products/:productId" component={ProductDetails} />
            <Route path="/products" component={ProductsTable} />

            <Route path="/categories/:categoryId" component={CategoryDetails} />
            <Route path="/categories" component={CategoriesTable} />
            <Route path="/suppliers" component={Suppliers} />

            <Route path="/materials/:materialId" component={MaterialDetails} />
            <Route path="/materials" component={MaterialsTable} />

            <Route path="/dashboard/addCompany" component={CreateCompany} />

            <Route path="/admin/:accountId" component={CreateEditAdmin} />
            <Route path="/admin" component={AdminsTable} />

            <Route path="/Installments/:installmentId" component={InstallmentsDetail} />
            <Route path="/Installments" component={InstallmentsTable} />

            <Route path="/dashboard/createAdmin" component={CreateAdmin} />

          </Switch>
        </main>}
      </Container>
    </>
  )
}
